export default {
      id: "ye-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#ye",
      toString: function () {
        return this.url;
      }
    }